module.exports = __webpack_public_path__ + "static/img/56.d0113d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/56.png
// module id = 5+1x
// module chunks = 1